module.exports = __webpack_public_path__ + "704911eced7c071f1dc1128b6b2b1581.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-dog-hello.png
// module id = 2060
// module chunks = 4